if (!customElements.get('klaim-pdp-essentials-set-builder')) {
  customElements.define('klaim-pdp-essentials-set-builder', class KlaimEssentialsSetBuilder extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const products = JSON.parse(this.querySelector('[data-klaim-set-products]')?.textContent || '[]');
      this.products = products.filter((product, index) => {
        return products.findIndex((entry) => entry.handle === product.handle) === index;
      });
      this.pack = 0;
      this.currentHandle = this.dataset.currentHandle || window.location.pathname.split('/products/')[1]?.split(/[?#/]/)[0] || '';
      this.itemsRoot = this.querySelector('[data-set-items]');
      this.submitButton = this.querySelector('[data-set-submit]');
      this.errorElement = this.querySelector('[data-set-error]');
      this.productInfo = this.closest('product-info');
      this.quickAddModal = this.closest('quick-add-modal');
      this.productInfo?.classList.add('klaim-pdp-essentials-set-builder-active');
      this.quickAddModal?.classList.add('klaim-set-quick-add-active');

      this.querySelectorAll('[data-pack]').forEach((button) => {
        button.addEventListener('click', () => this.selectPack(Number(button.dataset.pack)));
      });
      this.submitButton?.addEventListener('click', () => this.addToCart());
      this.renderItems();
      this.updateState();
    }

    disconnectedCallback() {
      this.productInfo?.classList.remove('klaim-pdp-essentials-set-builder-active');
      this.quickAddModal?.classList.remove('klaim-set-quick-add-active');
    }

    selectPack(pack) {
      if (![1, 2, 3].includes(pack)) return;
      this.pack = pack;
      this.querySelectorAll('[data-pack]').forEach((button) => {
        const selected = Number(button.dataset.pack) === pack;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
      this.renderItems();
      this.showError('');
      this.updateState();
    }

    renderItems() {
      this.itemsRoot.innerHTML = '';
      for (let index = 0; index < this.pack; index += 1) {
        this.itemsRoot.appendChild(this.createItem(index));
      }
    }

    createItem(index) {
      const wrapper = document.createElement('div');
      wrapper.className = 'klaim-set-builder__item';
      wrapper.dataset.setIndex = String(index);
      wrapper.dataset.productHandle = '';
      wrapper.innerHTML = `
        <div class="klaim-set-builder__item-head">
          <strong>SET ${String(index + 1).padStart(2, '0')}</strong>
          <span data-selected-product>CHOOSE SET</span>
        </div>`;
      wrapper.insertAdjacentHTML('beforeend', `
        <div class="klaim-set-builder__swatches" role="group" aria-label="Choose product for set ${index + 1}">
          ${this.products.map((item) => `
            <button
              type="button"
              class="klaim-set-builder__swatch"
              data-product-handle="${this.escapeHtml(item.handle)}"
              aria-label="${this.escapeHtml(item.title)}"
              aria-pressed="false"
            >
              <img src="${this.escapeHtml(item.image)}" alt="" width="80" height="80" loading="lazy">
            </button>`).join('')}
        </div>
        <div class="klaim-set-builder__sizes" hidden>
          <div class="klaim-set-builder__field"><label>SHIRT SIZE</label><select data-shirt-size required aria-label="Shirt size for set ${index + 1}">${this.sizeOptions()}</select></div>
          <div class="klaim-set-builder__field"><label>SHORTS SIZE</label><select data-short-size required aria-label="Shorts size for set ${index + 1}">${this.sizeOptions()}</select></div>
        </div>`);

      wrapper.querySelectorAll('[data-product-handle]').forEach((button) => {
        button.addEventListener('click', () => {
          const selected = this.products.find((item) => item.handle === button.dataset.productHandle);
          if (!selected) return;
          if (wrapper.dataset.productHandle === selected.handle && button.classList.contains('is-selected')) return;
          wrapper.dataset.productHandle = selected.handle;
          wrapper.querySelector('[data-selected-product]').textContent = selected.title;
          wrapper.querySelector('[data-shirt-size]').innerHTML = this.sizeOptions(selected);
          wrapper.querySelector('[data-short-size]').innerHTML = this.sizeOptions(selected);
          wrapper.querySelector('.klaim-set-builder__sizes').hidden = false;
          wrapper.querySelectorAll('[data-product-handle]').forEach((swatch) => {
            const isSelected = swatch === button;
            swatch.classList.toggle('is-selected', isSelected);
            swatch.setAttribute('aria-pressed', String(isSelected));
          });
          button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          this.showError('');
          this.updateState();
        });
      });
      wrapper.querySelectorAll('select').forEach((select) => {
        select.addEventListener('change', () => {
          this.showError('');
          this.updateState();
        });
      });
      return wrapper;
    }

    escapeHtml(value) {
      return String(value || '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
    }

    sizeOptions(product) {
      const placeholder = '<option value="" selected disabled>CHOOSE SIZE</option>';
      if (!product) return placeholder;
      return placeholder + product.variants.map((variant) => `<option value="${variant.id}"${variant.available ? '' : ' disabled'}>${variant.title}${variant.available ? '' : ' - SOLD OUT'}</option>`).join('');
    }

    getIncompleteChoice() {
      if (!this.pack) return this.querySelector('[data-pack]');
      const items = Array.from(this.itemsRoot.querySelectorAll('.klaim-set-builder__item'));
      for (const item of items) {
        if (!item.dataset.productHandle) return item.querySelector('[data-product-handle]');
        const shirtSelect = item.querySelector('[data-shirt-size]');
        const shortSelect = item.querySelector('[data-short-size]');
        if (!shirtSelect?.value) return shirtSelect;
        if (!shortSelect?.value) return shortSelect;
      }
      return null;
    }

    isSelectionComplete() {
      if (!this.pack) return false;
      const items = Array.from(this.itemsRoot.querySelectorAll('.klaim-set-builder__item'));
      return items.length === this.pack && items.every((item) => {
        return Boolean(
          item.dataset.productHandle &&
          item.querySelector('[data-shirt-size]')?.value &&
          item.querySelector('[data-short-size]')?.value
        );
      });
    }

    getActionLabel() {
      if (!this.pack) return 'CHOOSE NUMBER OF SETS';
      const items = Array.from(this.itemsRoot.querySelectorAll('.klaim-set-builder__item'));
      const missingProduct = items.find((item) => !item.dataset.productHandle);
      if (missingProduct) return `CHOOSE SET ${String(Number(missingProduct.dataset.setIndex) + 1).padStart(2, '0')}`;
      const missingSize = items.find((item) => {
        return !item.querySelector('[data-shirt-size]')?.value || !item.querySelector('[data-short-size]')?.value;
      });
      if (missingSize) return `CHOOSE SIZES FOR SET ${String(Number(missingSize.dataset.setIndex) + 1).padStart(2, '0')}`;
      return this.pack === 1 ? 'ADD SET TO BAG' : `ADD ${this.pack} SETS TO BAG`;
    }

    updateState() {
      const complete = this.isSelectionComplete();
      this.dataset.selectionComplete = String(complete);
      if (!this.submitButton) return;
      this.submitButton.disabled = this.busy || !complete;
      this.submitButton.textContent = this.busy ? 'ADDING YOUR SET...' : this.getActionLabel();
    }

    focusIncompleteChoice() {
      const choice = this.getIncompleteChoice();
      this.showError('Choose the number of sets, a set, shirt size and shorts size before adding to bag.');
      choice?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
      window.setTimeout(() => choice?.focus(), 350);
    }

    getSelections() {
      if (!this.isSelectionComplete()) return [];
      return Array.from(this.itemsRoot.querySelectorAll('.klaim-set-builder__item')).map((item) => {
        const product = this.products.find((entry) => entry.handle === item.dataset.productHandle);
        const shirtSelect = item.querySelector('[data-shirt-size]');
        const shortSelect = item.querySelector('[data-short-size]');
        return {
          id: Number(shirtSelect.value),
          quantity: 1,
          properties: {
            'Shirt size': shirtSelect.options[shirtSelect.selectedIndex].text.replace(' - SOLD OUT', ''),
            'Short size': shortSelect.options[shortSelect.selectedIndex].text.replace(' - SOLD OUT', ''),
            '_klaim_essentials_set': 'true',
            '_klaim_set_product': product.title
          }
        };
      });
    }

    showError(message) {
      this.errorElement.textContent = message;
      this.errorElement.hidden = !message;
    }

    async addToCart() {
      if (this.busy) return;
      if (!this.isSelectionComplete()) {
        this.focusIncompleteChoice();
        return;
      }
      this.busy = true;
      this.showError('');
      this.updateState();
      const cartDrawer = document.querySelector('cart-drawer');
      const quickAddModal = this.quickAddModal;
      const sections = cartDrawer ? cartDrawer.getSectionsToRender().map((section) => section.id) : [];

      try {
        const addResponse = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: this.getSelections(), sections, sections_url: window.location.pathname })
        });
        const addState = await addResponse.json();
        if (!addResponse.ok || addState.status) throw new Error(addState.description || 'One of these sizes is no longer available.');

        const cartState = await window.KlaimEssentialsSetDiscount.sync({ sections });

        if (cartDrawer && cartState.sections) {
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              cartDrawer.suppressAutomaticGiftModalOnce?.();
              cartDrawer.renderContents(cartState);
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            cartDrawer.renderContents(cartState);
          }
        } else {
          window.sessionStorage.setItem('klaim-open-cart-drawer', 'true');
          window.location.assign('/');
        }
      } catch (error) {
        this.showError(error.message || 'Your set could not be added. Please try again.');
      } finally {
        this.busy = false;
        this.updateState();
      }
    }
  });
}

window.KlaimEssentialsSetDiscount = window.KlaimEssentialsSetDiscount || {
  codes: ['KLAIMSETS2', 'KLAIMSETS3'],
  busy: false,

  getQuantity(cart) {
    return (cart.items || []).reduce((quantity, item) => {
      return item.properties?._klaim_essentials_set === 'true' ? quantity + item.quantity : quantity;
    }, 0);
  },

  async sync({ sections = [] } = {}) {
    if (this.busy) return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
    this.busy = true;

    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
      const quantity = this.getQuantity(cart);
      const desiredCode = quantity >= 3 ? this.codes[1] : quantity >= 2 ? this.codes[0] : '';
      const retainedCodes = (cart.discount_codes || [])
        .filter((discount) => discount.applicable && !this.codes.includes(discount.code))
        .map((discount) => discount.code);

      if (desiredCode) retainedCodes.push(desiredCode);

      const response = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          discount: retainedCodes.join(','),
          sections,
          sections_url: window.location.pathname
        })
      });
      const state = await response.json();
      if (!response.ok || state.status) {
        throw new Error(state.description || 'The bundle price could not be applied.');
      }
      return state;
    } finally {
      this.busy = false;
    }
  }
};
